<template>
  <div class="grid grid-cols-7 gap-3">
    <Button
      v-for="dayOption in dayOptions"
      :key="dayOption.value"
      :class="['text-xs']"
      :outline="!isSelected(dayOption.value)"
      :disabled="disabled"
      @click="toggleDay(dayOption.value)"
      >{{ dayOption.label }}</Button
    >
  </div>
</template>

<script setup lang="ts">
import Button from "@/components/Button.vue";
import { Weekday } from "@/typings/calendarEvent";
import { dayOptions } from "@/typings/calendarEventForm";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps<{
  modelValue: Weekday[];
  disabled?: boolean;
}>();

function toggleDay(clickedDay: Weekday) {
  document.activeElement.blur();

  let newDays = props.modelValue;

  if (isSelected(clickedDay)) {
    newDays = newDays.filter((item) => item !== clickedDay);
  } else {
    newDays.push(clickedDay);
  }

  emit("update:modelValue", newDays);
}

function isSelected(day: Weekday): boolean {
  return props.modelValue?.includes(day);
}
</script>

<style scoped lang="scss"></style>
